import { FURNITUREFITTINGCONSTANTS, INPUT_TYPE } from "../../../../constants/Constant";
import { getIRASReportYears } from "../../../../managers/common/CommonUtil";
import { INPUT_VIEW_DIRECTION } from "../../../SequenceNumberFormat/Other";
import ic_archive from "../../../../../src/assets/icons/white/ic_archive.png"
import calender from '../../../../../src/assets/icons/white/date_range.svg'
import { COUNTRIES_WITH_CURRENCIES } from "../../../../constants/Currencies";
import {DKIcons} from "deskera-ui-library";
import {Nationalities} from "../../../../constants/CountryConstant"
import {Countries} from "../../../../components/add-employee/steps/Employee"

export const REPORTS_CONFIGS = {
    CPF_E_SUBMISSION : {
        FORM_HEADING: "CPF E-Submission",
        FORM_DESCRIPTION: "Generate CPF E-Submission File",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 1,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "month",
                index: 2,
                name: "Month",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid month",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "cpfSubmissionFile",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                isLoading: false,
                buttonConfig: {
                    title: "CPF E-Submission File",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            }
        ]
    },
    IR8A_FORM : {
        FORM_HEADING: "IR8A Form Download",
        FORM_DESCRIPTION: "IR8A Form",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "employee",
                index: 1,
                name: "Employee",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid employee",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 2,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            }
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "ir8aFormDownload",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"IR8A",
                isLoading: false,
                buttonConfig: {
                    title: "Download Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            },
            {
                columnCode: "editIR8AForm",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                isLoading: false,
                buttonConfig: {
                    title: "Edit Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-gray1 border-m ml-m",
                    styles:"",
                    isIcon: true,
                    icon:DKIcons.ic_edit,
                    iconClass:"",
                }
            }
        ]
    },
    IR8S_FORM : {
        FORM_HEADING: "IR8S Form Download",
        FORM_DESCRIPTION: "IR8S Form",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "employee",
                index: 1,
                name: "Employee",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid employee",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 2,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            }
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "ir8sFormDownload",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"IR8S",
                isLoading: false,
                buttonConfig: {
                    title: "Download Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            },
            {
                columnCode: "editIR8SForm",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"IR8S_FORM",
                isLoading: false,
                buttonConfig: {
                    title: "Edit Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white ml-m",
                    styles:"",
                    isIcon: false,
                    icon:'',
                    iconClass:"",
                }
            }
        ]
    },
    APPENDIX_8A : {
        FORM_HEADING: "Appendix 8A",
        FORM_DESCRIPTION: "Appendix 8A",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "employee",
                index: 1,
                name: "Employee",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid employee",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 2,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            }
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "appendix8aDownload",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"APPENDIX_8A",
                isLoading: false,
                buttonConfig: {
                    title: "Download Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            },
            {
                columnCode: "editAppendix8a",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"APPENDIX_8A",
                isLoading: false,
                buttonConfig: {
                    title: "Edit Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-gray1 border-m ml-m",
                    styles:"",
                    isIcon: true,
                    icon:DKIcons.ic_edit,
                    iconClass:"",
                }
            }
        ]
    },
    APPENDIX_8B : {
        FORM_HEADING: "Appendix 8B",
        FORM_DESCRIPTION: "Appendix 8B",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "employee",
                index: 1,
                name: "Employee",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid employee",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 2,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            }
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "appendix8aDownload",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"APPENDIX_8B",
                isLoading: false,
                buttonConfig: {
                    title: "Download Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            },
            {
                columnCode: "editAppendix8BForm",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                isLoading: false,
                buttonConfig: {
                    title: "Edit Form",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-gray1 border-m ml-m",
                    styles:"",
                    isIcon: true,
                    icon:DKIcons.ic_edit,
                    iconClass:"",
                }
            }
        ]
    },
    IRAS_E_SUBMISSION : {
        FORM_HEADING: "IRAS E-Submission",
        FORM_DESCRIPTION: "Generate IRAS E-Submission File",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                index: 2,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "formType",
                index: 1,
                name: "IRAS Form Type",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid form type",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
        ],
        IS_SECOND_SECTION: true,
        SECOND_SECTION : [
            {
                columnCode: "irasESubmissionDownload",
                type: INPUT_TYPE.BUTTON,
                index: 0,
                required: true,
                uiVisible: true,
                width: "20%",
                isButton:true,
                formName:"IRAS_E_SUBMISSION",
                isLoading: false,
                buttonConfig: {
                    title: "Download File",
                    buttonClass:{marginTop:""},
                    buttonStyle:"",
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:ic_archive,
                    iconClass:"",
                }
            }
        ]
    },
}

export const CPFMonth = [
    {
        id: 1,
        name: 'Jan'
    },
    {
        id: 2,
        name: 'Feb'
    },
    {
        id: 3,
        name: 'Mar'
    },
    {
        id: 4,
        name: 'Apr'
    },
    {
        id: 5,
        name: 'May'
    },
    {
        id: 6,
        name: 'Jun'
    },
    {
        id: 7,
        name: 'Jul'
    },
    {
        id: 8,
        name: 'Aug'
    },
    {
        id: 9,
        name: 'Sep'
    },
    {
        id: 10,
        name: 'Oct'
    },
    {
        id: 11,
        name: 'Nov'
    },
    {
        id: 12,
        name: 'Dec'
    }
];
export const IRASSummaryReportForm = [
    
    {
        key:"year",
        columnCode: "year",
        options:getIRASReportYears(),
        icon:"",
        validation:null,
        isValid:true,
        name:"Basic Year",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"status",
        columnCode: "status",
        options:[{id:'SUBMITTED',name:"Submitted"},{id:'READY_FOR_SUBMISSION',name:"Not Submitted"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Status",
        type:INPUT_TYPE.RADIO_BUTTON,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"format",
        columnCode: "format",
        options:[{id:'XLS',name:"Excel"},{id:'PDF',name:"PDF"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"File Format",
        type:INPUT_TYPE.RADIO_BUTTON,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    }
]

export const US_FORM_FIELDS = {
    ["CPF_E_SUBMISSION"] : ["cpfAccount","year", "month"],
    ["IR8A_FORM"] : ["cpfAccount","employee", "year"],
    ["IR8S_FORM"] : ["cpfAccount","employee", "year"],
    ["APPENDIX_8A"] : ["cpfAccount","employee", "year"],
    ["APPENDIX_8B"] : ["cpfAccount","employee", "year"],
    ["IRAS_E_SUBMISSION"] : ["cpfAccount","year","formType"]
}

export const IRAS_FORM_TYPE = [
    {
      id: 'IR8A',
      name: 'IR8A'
    },
    {
      id: 'IR8S',
      name: 'IR8S'
    },
    {
      id: 'APPENDIX_8A',
      name: 'Appendix 8A'
    },
    {
      id: 'APPENDIX_8B',
      name: 'Appendix 8B'
    }
  ];

  export const IRAS_SUBMISSION_FIELDS = {
    "IRAS Submission" : {
        KEY:"SUBMISSION",
        FORM_DESCRIPTION: "IRAS Submission",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                className:"pr-l mt-r",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "30%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                className:"pr-l mt-r",
                index: 1,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "25%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "bypass",
                index: 2,
                name: "Bypass",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "20%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Select a valid indicator",
                hasTooltip: true,
                tooltipText: "<b>Indicator to whether to bypass warning messages thrown and proceed with Submission.</b><br>If bypass = true, hit warning and proceed with submission.<br>If bypass = false, respond as error with no submission.",
                isCustomOptions:true,
                options:[{id:true, name: "True"},{id:false, name: "False"}],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "fetchIRASSubmission",
                type: INPUT_TYPE.BUTTON,
                index: 3,
                required: true,
                uiVisible: true,
                width: "30%",
                isButton:true,
                formName:"AIS Submission",
                isLoading: false,
                buttonConfig: {
                    title: "Fetch",
                    buttonClass:"ml-xl",
                    buttonStyle:{marginTop:"28px"},
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: false,
                    icon:"",
                    iconClass:"",
                }
            }
        ]
    },
    "IRAS Submission File" : {
        KEY:"SUBMISSION_FILE",
        FORM_DESCRIPTION: "IRAS Submitted File",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "cpfAccount",
                className:"pr-l",
                index: 0,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "year",
                className:"pr-l",
                index: 1,
                name: "Year",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid year",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "fetchIRASSubmittedFile",
                type: INPUT_TYPE.BUTTON,
                index: 2,
                required: true,
                uiVisible: true,
                width: "30%",
                isButton:true,
                formName:"AIS Submitted File",
                isLoading: false,
                buttonConfig: {
                    title: "Fetch",
                    buttonClass:"ml-xl",
                    buttonStyle:{marginTop:"20px"},
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: false,
                    icon:"",
                    iconClass:"",
                }
            }
        ]
    },
    "IRAS Submission & Validation Log" : {
        KEY:"SUBMISSION_LOG",
        FORM_DESCRIPTION: "IRAS Submission Log",
        BACK_BUTTON: true,
        FIRST_SECTION : [
            {
                columnCode: "datePeriod",
                index: 0,
                name: "Date Period",
                required: true,
                type: "Calendar",
                uiVisible: true,
                width: "25%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid range",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false,
                defaultDate: false,
                toggle: false,
                isButton:true,
                buttonConfig: {
                    title: "",
                    buttonClass:"mr-xl",
                    buttonStyle:{marginTop:"20px"},
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: true,
                    icon:calender,
                    iconClass:"",
                }
            },
            {
                columnCode: "cpfAccount",
                className:"pr-xl",
                index: 1,
                name: "CPF Account",
                required: true,
                type: INPUT_TYPE.DROPDOWN,
                uiVisible: true,
                width: "33%",
                direction: "VERTICAL",
                hasError:false,
                errMsg:"Enter a valid CPF account",
                hasTooltip: false,
                tooltipText: "",
                isCustomOptions:true,
                options:[],
                displayKey:"name",
                searchableKey: "name",
                readOnly: false
            },
            {
                columnCode: "generateSubmissionLog",
                type: INPUT_TYPE.BUTTON,
                index: 2,
                required: true,
                uiVisible: true,
                width: "30%",
                isButton:true,
                formName:"AIS Submission and Validation",
                isLoading: false,
                buttonConfig: {
                    title: "Generate Log",
                    buttonClass:"",
                    buttonStyle:{marginTop:"20px"},
                    className:"bg-app text-white",
                    styles:"",
                    isIcon: false,
                    icon:"",
                    iconClass:"",
                }
            }
        ]
    },
  }

  export const IRAS_MESSAGES = {
    VALIDATE_RECORDS: "Validate Record(s)?",
    VALIDATE_SUBMIT_RECORS: "Validate and Submit Record(s)?",
    VALIDATE_CONFIRMATION: "Do you want to validate selected users' IRAS details through API submission?",
    VALIDATE_AND_SUBMIT_CONFIRMATION: "Do you want to submit selected users' IRAS details through API submission?",
    VALIDATION_SUCCESSFULL: "IRAS details of selected users have been validated. Please check submission log for details.",
    VALIDATION_FAIL: "IRAS details of selected users have failed validation. Please check submission log for details.",
    SUBMISSION_SUCCESSFULL: "IRAS details of selected users have been submitted. Please check submission log for details.",
    SUBMISSION_FAIL: "IRAS details of selected users have failed submittion. Please check submission log for details."
  }
  
export const SG_CONSTANT = {
    status : {
        SUBMITTED: "SUBMITTED",
        READY_FOR_SUBMISSION : "READY_FOR_SUBMISSION"
    }
}

export const EDIT_APPENDIX_8A_FORM = {
    employeeDetail: [
        {
            key:"employeeName",
            columnCode: "employeeName",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Full name of employee as per NRIC/FIN",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true
        },
        {
            key:"taxRefNo",
            columnCode: "taxRefNo",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Employee's Tax. Re. No. NRIC/FIN",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true,
            showMask:true,
            showMaskUnmaskInline: true
        },
        {
            key:"addressLine1",
            columnCode: "addressLine1",
            options:[],
            icon:"",
            validation:{
                maxLength:30
            },
            isValid:true,
            name:"Address Line 1",
            type:INPUT_TYPE.TEXT,
            errorMessage:"Address Line 1 should not exceed 30 letters",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true,
            tooltipText:"Address Line 1 should not exceed 30 letters"
        },
        {
            key:"addressLine2",
            columnCode: "addressLine2",
            options:[],
            icon:"",
            validation:{
                maxLength:25
            },
            isValid:true,
            name:"Address Line 2",
            type:INPUT_TYPE.TEXT,
            errorMessage:"Address Line 2 should not exceed 25 letters",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true,
            tooltipText:"Address Line 2 should not exceed 25 letters"
        },
        {
            key:"addressLine3",
            columnCode: "addressLine3",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Address Line 3",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: false
        },
        {
            key:"zipCode",
            columnCode: "zipCode",
            options:[],
            icon:"",
            validation:{
                maxLength:6
            },
            isValid:true,
            name:"Zipcode",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Zipcode should not exceed 6 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true,
            tooltipText: "Zipcode should not exceed 6 digits"
        },
        {
            key:"state",
            columnCode: "state",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Region/State",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"country",
            columnCode: "country",
            options:COUNTRIES_WITH_CURRENCIES.map(country=>{return{id:country.countryCode, name: country.country}}),
            icon:"",
            validation:null,
            isValid:true,
            name:"Country",
            type:INPUT_TYPE.DROPDOWN,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"noOfEmpSharingPremises",
            columnCode: "noOfEmpSharingPremises",
            options:[],
            icon:"",
            validation:{
                maxLength:2
            },
            isValid:true,
            name:"No. of Employee Sharing quarter",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 2 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"occupationPeriod",
            columnCode: "occupationPeriod",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Period of Occupation",
            type:'date-range',
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true
        },
        {
            key:"days",
            columnCode: "days",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"No. of days",
            type:INPUT_TYPE.NUMBER,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: true,
            uiVisible: true
        }
    ],
    accommodationDetail: [
        {
            key:"annualValue",
            columnCode: "annualValue",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2a. Annual Value (AV) of Premises for the period provided (state apportined amount, if applicable)",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"furnitureAndFittingType",
            columnCode: "furnitureAndFittingType",
            options: FURNITUREFITTINGCONSTANTS,
            icon:"",
            validation:null,
            isValid:true,
            name:"2b. Value of Furniture and Fitting",
            type:INPUT_TYPE.DROPDOWN,
            errorMessage:"Please select a value",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true,
            tooltipText: "40% of AV if premises is partially furnished or\n50% of AV if premises is fully furnished",
            tooltipClass: "tooltip-r1"
        },
        {
            key:"rentPaid",
            columnCode: "rentPaid",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2c. Rent paid by employer including rental of Furniture & Fittings (state apportined amount, if applicable)",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true,
            tooltipText: "2c is mandatory if 2a and 2b are not completed"
        },
        {
            key:"taxableValueOfRec",
            columnCode: "taxableValueOfRec",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2d. Taxable Value of Place of Residence",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true,
            tooltipText: "2d is calculated as (2a + 2b) or 2c",
            tooltipClass: "tooltip-r1"
        },
        {
            key:"rentPaidByEmp",
            columnCode: "rentPaidByEmp",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2e. Total Rent paid by employee for Place of Residence",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"totalTaxableValueOfRec",
            columnCode: "totalTaxableValueOfRec",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2f. Total Taxable value of Place of Residence",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true,
            tooltipText: "2f is calculated as (2d - 2e)",
            tooltipClass: "tooltip-r1"
        },
        {
            key:"utilityActualAmount",
            columnCode: "utilityActualAmount",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2g. Utilities/Telephone/Pager/Suitcase/Golf Bag & Accessories/Camera/Electronic Gadget (eg. Tablet, Laptop. etc)",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"driverActualAmount",
            columnCode: "driverActualAmount",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2h. Driver [Annual Wages x (Private/Total Mileage)]",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"servantActualAmount",
            columnCode: "servantActualAmount",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2i. Servant/Gardener/Upkeep of Compound [Annual Wages or actual amount paid by employer to a company to perform these services]",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"taxableValueOfUtilsAndHousekeeping",
            columnCode: "taxableValueOfUtilsAndHousekeeping",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"2j. Taxable value of utilities and housekeeping costs",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true,
            tooltipText: "2j is calculated as (2g + 2h + 2i)",
            tooltipClass: "tooltip-r1"
        }
    ],
    hotelAccommodationDetail: [
        {
            key:"actualHotelAccommodation",
            columnCode: "actualHotelAccommodation",
            options:[],
            icon:"",
            validation:{
                maxLength:9,
                minValue:0
            },
            isValid:true,
            name:"3a. Actual cost of Hotel accommodation/Serviced Apartment within hotel building",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 9 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"hotelAccommodationAmountEmployee",
            columnCode: "hotelAccommodationAmountEmployee",
            options:[],
            icon:"",
            validation:{
                maxLength:9,
                minValue:0
            },
            isValid:true,
            name:"3b. Amount paid by the employee",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 9 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"taxableHotelAccommodation",
            columnCode: "taxableHotelAccommodation",
            options:[],
            icon:"",
            validation:{
                maxLength:9,
                minValue:0
            },
            isValid:true,
            name:"3c. Taxable Value of Hotel Accommodation",
            type:INPUT_TYPE.NUMBER,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: true,
            uiVisible: true,
            tooltipText:"3c is calculated as (3a - 3b)"
        }
    ],
    otherDetail:[
        
        {
            key:"costOfHomeLeavePassages",
            columnCode: "costOfHomeLeavePassages",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4a. Cost of home leave passages and incidental benefits provided to employee and his family:",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"interestPaymentMadeByEmployer",
            columnCode: "interestPaymentMadeByEmployer",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4b. Interest payment made by the employer to a third party on behalf of an employee and/or interest benefits arising from loans provided by employer interest free or at a rate below market rate to the employee who has substantial shareholding or control or influence over the company",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"insurancePremiumPaidByEmployer",
            columnCode: "insurancePremiumPaidByEmployer",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4c. Insurance premiums paid by the employer",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"freeHolidays",
            columnCode: "freeHolidays",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4d. Free or subsidised holidays including air passage etc" ,
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"educationalExpenses",
            columnCode: "educationalExpenses",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4e. Educational expenses including tutor provided",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"entranceFees",
            columnCode: "entranceFees",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4f. Entrance/transfer fees and annual subscription to social or recreational clubs",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"gainFromAssets",
            columnCode: "gainFromAssets",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4g. Gains from assets, e.g. vehicles, property, etc. sold to employees at a price lower than open market value",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"fullCostOfVehicles",
            columnCode: "fullCostOfVehicles",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4h. Full cost of motor vehicles given to employee",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"carBenefits",
            columnCode: "carBenefits",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4i. Car benefits",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"otherNonMonetaryAwards",
            columnCode: "otherNonMonetaryAwards",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minValue:0
            },
            isValid:true,
            name:"4j. Other non-monetary awards/benefits which do not fall within the above items",
            type:INPUT_TYPE.NUMBER,
            errorMessage:"Length should not exceed 10 digits",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        }
    ]
}


  export const Genders = [
    {
        id: 'all',
        name: 'All'
    },
    {
        id: 'male',
        name: 'Male'
    },
    {
        id: 'female',
        name: 'Female'
    }
];

export const LOSS_OF_OFFICE = [
  {
    id: 1,
    name: 'Yes'
  },
  {
    id: 2,
    name: 'No'
  }
];

export const IR8A_APPROVAL_OBTAIN_LIST = [
  {
    id: 'Y',
    name: 'Yes'
  },
  {
    id: 'N',
    name: 'No'
  }
];

export const EXEMPT_REMISSION_INCOME_LIST  = [
  {
    id: 1,
    name: 'Tax Remission on Overseas Cost of Living Allowance (OCLA)'
  },
  {
    id: 3,
    name: 'Seaman'
  },
  {
    id: 4,
    name: 'Exemption'
  },
  {
    id: 5,
    name: 'Overseas Pension Fund with Tax Concession'
  },
  {
    id: 6,
    name: 'Income from Overseas Employment'
  },
  {
    id: 7,
    name: 'Income from Overseas Employment and Overseas Pension Fund with Tax Concession'
  }
];

export const EMPLOYEE_INCOME_TAX_BORN_BY_EMPLOYER_LIST = [
  {
    id: 'none',
    name: 'None'
  },
  {
    id: 'F',
    name: 'Tax fully borne by employer on employment income only'
  },
  {
    id: 'P',
    name: 'Tax partially borne by employer on certain employment income items'
  },
  {
    id: 'H',
    name: 'A fixed amount of income tax liability borne by employee'
  }
];

export const IR8A_BANKDETAILS = [
  {
    id: "0",
    name: "NONE"
  },
  {
    id: "1",
    name: "DBS BANK LTD"
  }, {
    id: "2",
    name: "UNITED OVERSEAS BANK LIMITED"
  }, {
    id: "3",
    name: "OVERSEA-CHINESE BANKING CORPORATION LIMITED"
  }, {
    id: "4",
    name: "OTHERS"
  }, {
    id: "5",
    name: "CIMB BANK BERHAD"
  }, {
    id: "6",
    name: "CITIBANK SINGAPORE LIMITED"
  }, {
    id: "7",
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED"
  }, {
    id: "8",
    name: "MALAYAN BANKING BERHAD"
  }, {
    id: "9",
    name: "STANDARD CHARTERED BANK"
  }, {
    id: "A",
    name: "FAR EASTERN BANK LTD"
  }, {
    id: "B",
    name: "AUSTRALIA & NEW ZEALAND BANKING GROUP LIMITED"
  }, {
    id: "C",
    name: "BANGKOK BANK PUBLIC COMPANY LIMITED"
  }, {
    id: "D",
    name: "BANK OF AMERICA, NATIONAL ASSOCIATION"
  }, {
    id: "E",
    name: "BANK OF CHINA LIMITED"
  }, {
    id: "F",
    name: "BANK OF EAST ASIA LTD"
  }, {
    id: "G",
    name: "BANK OF INDIA"
  }, {
    id: "H",
    name: "BANK OF TOKYO-MITSUBISHI UFJ, LTD"
  }, {
    id: "I",
    name: "BNP PARIBAS"
  }, {
    id: "J",
    name: "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK"
  }, {
    id: "K",
    name: "HL BANK"
  }, {
    id: "L",
    name: "ICICI BANK LIMITED"
  }, {
    id: "M",
    name: "INDIAN BANK"
  }, {
    id: "N",
    name: "INDIAN OVERSEAS BANK"
  }, {
    id: "O",
    name: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED"
  }, {
    id: "P",
    name: "JPMORGAN CHASE BANK, N.A."
  }, {
    id: "Q",
    name: "MIZUHO CORPORATE BANK, LTD"
  }, {
    id: "R",
    name: "PT BANK NEGARA INDONESIA (PERSERO) TBK"
  }, {
    id: "S",
    name: "RHB BANK BERHAD"
  }, {
    id: "T",
    name: "STATE BANK OF INDIA"
  }, {
    id: "U",
    name: "SUMITOMO MITSUI BANKING CORPORATION"
  }, {
    id: "V",
    name: "UCO BANK"
  },
]

export const SECTION_45_INDICATOR  = [
    {
      id: "NA",
      name: 'Not Applicable'
    },
    {
      id: "true",
      name: "Yes"
    },
    {
      id: "false",
      name: "No"
    }
  ];

  export const IR8S_FORM_CONFIG = [
      {
          sectionNo:"1",
          title:"Employee Details",
          defaultState: "expanded",
          fields :[
              {columnCode: "employee", name:"Employee", type: INPUT_TYPE.TEXT, validation: ["required"], readOnly: true},
              {columnCode: "employeeNricFin", name:"Employee's Tax Ref.No.:*NRIC/FIN", type: INPUT_TYPE.TEXT, maxLength:12, validation: ["required","maxLength"], tooltipText:"Characters should not exceed 12 letters"},
              {columnCode: "employeeUen", name:"Employer's Tax Ref.No./UEN", type: INPUT_TYPE.TEXT,  minLength:9, maxLength:10, validation: ["required", "minLength","maxLength"], tooltipText:"Characters should be minimum 9 letters and not exceed 10 letters"},
              {columnCode: "fullNameOfEmployee", name:"Full Name of employee as per NRIC/FIN", type: INPUT_TYPE.TEXT, maxLength:40, validation: ["required", "maxLength"], tooltipText:"Characters should not exceed 40 letters"},
              {columnCode: "designation", name:"Job Title", type: INPUT_TYPE.TEXT, maxLength:40, validation: ["required", "maxLength"], tooltipText:"Characters should not exceed 30 letters"},
              {columnCode: "dateOfBirth", name:"Date of Birth", type: INPUT_TYPE.DATE, validation: ["required"]},
              {columnCode: "sex", name:"Sex", type: INPUT_TYPE.DROPDOWN, options: Genders},
              {columnCode: "nationality", name:"Nationality", type: INPUT_TYPE.DROPDOWN, options: Nationalities},
              {columnCode: "addressLine1", name:"Block/House No.", type: INPUT_TYPE.TEXT, maxLength:25, validation: ["maxLength"], tooltipText:"Characters should not exceed 25 letters"},
              {columnCode: "addressLine2", name:"Street Name", type: INPUT_TYPE.TEXT, maxLength:25, validation: ["maxLength"], tooltipText:"Characters should not exceed 25 letters"},
              {columnCode: "zipCode", name:"Zip Code", type: INPUT_TYPE.NUMBER},
              {columnCode: "city", name:"Level No.", type: INPUT_TYPE.TEXT},
              {columnCode: "state", name:"Unit No.", type: INPUT_TYPE.TEXT},
              {columnCode: "country", name:"Country", type: INPUT_TYPE.DROPDOWN, options: Countries.map((country) => {return {id: country.code, name: country.name, ...country} })},
              {columnCode: "bankOfSalaryCredit", name:"Bank to which salary is credited", type: INPUT_TYPE.DROPDOWN, options: IR8A_BANKDETAILS},
              {columnCode: "dateOfCommensement", name:"Date of Commencement", type: INPUT_TYPE.DATE, validation: ["required"]},
              {columnCode: "dateOfCessation", name:"Date of Cessation", type: INPUT_TYPE.DATE}
            ]
      },
      {
        sectionNo:"2",
        title:"Income",
        defaultState: "expanded",
        fields :[
            {columnCode: "bonusDeclarationDate", name:"Bonus Declaration Date", type: INPUT_TYPE.DATE},
            {columnCode: "directorFeesApprovalDate", name:"Date of approval of director's fees", type: INPUT_TYPE.DATE},
            {columnCode: "section45Indicator", name:"Section 45", type: INPUT_TYPE.DROPDOWN, options:SECTION_45_INDICATOR},
        ]
    },
    {
      sectionNo:"3",
      title:"Allowances",
      defaultState: "expanded",
      fields :[
          {columnCode: "commissionPaymentFrom", name:"Start of Period of gross commission", type: INPUT_TYPE.DATE, lessThanFields:[{key:"commissionPaymentTo",name : "End of Period of gross commission"}], validation:["lessThan"]},
          {columnCode: "commissionPaymentTo", name:"End of Period of gross commission", type: INPUT_TYPE.DATE, greaterThanFields:[{key:"commissionPaymentFrom", name: "Start of Period of gross commission"}], validation:["greaterThan"]},
      ]
    },
    {
      sectionNo:"4",
      title:"Lump sum payment",
      defaultState: "expanded",
      fields :[
          {columnCode: "lossOfOffice", name:"Loss of Office", type: INPUT_TYPE.RADIO_BUTTON, radioButtonConfig:[{name:"Yes", columnCode:"lossOfOffice", value:1},{name:"No", columnCode:"lossOfOffice", value:2}]},
          {columnCode: "compensationLossofOfficeAmount", name:"Compensation Loss of Office Amount", type: INPUT_TYPE.NUMBER},
          {columnCode: "ir8sApprovalObtained", name:"IR8A Approval Obtained", type: INPUT_TYPE.DROPDOWN, options:IR8A_APPROVAL_OBTAIN_LIST},
          {columnCode: "ir8sApprovalDate", name:"IR8A Approval Date", type: INPUT_TYPE.DATE},
          {columnCode: "exemptRemissionIncomeIndicator", name:"Exempt Remission Income Indicator", type: INPUT_TYPE.DROPDOWN, options:EXEMPT_REMISSION_INCOME_LIST},
          {columnCode: "exemptIncomeTaxRemission", name:"Exempt Income Tax Remission", type: INPUT_TYPE.NUMBER},
          {columnCode: "employeeIncomeTaxBorneByEmployerIndicator", name:"Exempt Remission Income Born By Employer Indicator", type: INPUT_TYPE.DROPDOWN, options:EMPLOYEE_INCOME_TAX_BORN_BY_EMPLOYER_LIST},
          {columnCode: "employmentIncomeTaxbyEmployer", name:"Employee Income Tax By Employer", type: INPUT_TYPE.NUMBER},
          {columnCode: "fixedAmountIncomeTaxbornebyEmployee", name:"Fixed Amount Income Tax Borne By Employee", type: INPUT_TYPE.NUMBER },
          {columnCode: "employeeCpfContribution", name:"EMPLOYEE’S COMPULSORY contribution to *CPF/Designated Pension or Provident Fund", type: INPUT_TYPE.NUMBER, maxLength:5, validation:["noDecimal","maxLength"]},
          {columnCode: "donation", name:"Donations deducted from salaries for:*Yayasan Mendaki Fund/Community Chest of Singapore/SINDA/CDAC/ECF/Other tax exempt donations", type: INPUT_TYPE.NUMBER, maxLength:5, validation:["noDecimal","maxLength"]},
          {columnCode: "employeeMbmfContribution", name:"Contributions deducted from salaries to Mosque Building Fund:", type: INPUT_TYPE.NUMBER, maxLength:5, validation:["noDecimal","maxLength"]},
          {columnCode: "insurance", name:"Life Insurance premiums deducted from salaries:", type: INPUT_TYPE.NUMBER, maxLength:5, validation:["noDecimal", "maxLength"]}
      ]
    }
  ]

export const IR8A_EXTERNAL_FIELDS = [
    {columnCode:"A", expextedSection:2, expectedFieldPosition:1, validation:["noDecimal"]},
    {columnCode:"B", expextedSection:2, expectedFieldPosition:2, validation:["noDecimal"]},
    {columnCode:"C", expextedSection:2, expectedFieldPosition:4, validation:["noDecimal"]},
    {columnCode:"D11", expextedSection:3, expectedFieldPosition:1},
    {columnCode:"D12", expextedSection:3, expectedFieldPosition:2},
    {columnCode:"D13", expextedSection:3, expectedFieldPosition:3, name: "Others"},
    {columnCode:"D2", expextedSection:3, expectedFieldPosition:4, name:"Gross Commission for the period"},
    {columnCode:"D3", expextedSection:3, expectedFieldPosition:5},
    {columnCode:"D41", expextedSection:4, expectedFieldPosition:1},
    {columnCode:"D42", expextedSection:4, expectedFieldPosition:2},
    {columnCode:"D43", expextedSection:4, expectedFieldPosition:3, name: "Ex-gratia payment"},
    {columnCode:"D51", expextedSection:4, expectedFieldPosition:4, name: "Retirement benefits including gratuities/pension/commutation of pension/lump sum payments, etc", validation:["noDecimal"]},
    {columnCode:"D6", expextedSection:4, expectedFieldPosition:5, name:"Contributions made by employer to any Pension/Provident Fund constituted outside Singapore without tax concession:", validation:["noDecimal"]},
    {columnCode:"D7", expextedSection:4, expectedFieldPosition:6, name:"Excess/Voluntary contribution to CPF by employer (less amount refunded/to be refunded):"},
    {columnCode:"D8", expextedSection:4, expectedFieldPosition:7, name: "Gains or profits from Employee Stock Option", validation:["noDecimal"]},
    {columnCode:"D9", expextedSection:4, expectedFieldPosition:8},
]
export const EDIT_IR8S_FORM = {
    authorizePerson: [
        {
            key:"employeeName",
            columnCode: "employeeName",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Full name of employee as per NRIC/FIN",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: true,
            uiVisible: true
        },
        {
            key:"dob",
            columnCode: "dob",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Date of birth",
            type:INPUT_TYPE.DATE,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"uenNo",
            columnCode: "uenNo",
            options:[],
            icon:"",
            validation:{
                maxLength:10,
                minLength:9
            },
            isValid:true,
            name:"Employer's Tax Ref.No / UEN",
            type:INPUT_TYPE.TEXT,
            errorMessage:"Characters should be minimum 9 letters and not exceed 10 letters",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true,
            tooltipText: "Characters should be minimum 9 letters and not exceed 10 letters"
        },
        {
            key:"nricNo",
            columnCode: "nricNo",
            options:[],
            icon:"",
            validation:{
                maxLength:12
            },
            isValid:true,
            name:"Employee's Tax. Re. No. NRIC/FIN",
            type:INPUT_TYPE.TEXT,
            errorMessage:"Characters should not exceed 12 letters",
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true,
            showMask:true,
            tooltipText: "Characters should not exceed 12 letters",
            showMaskUnmaskInline: true
        },
        {
            key:"joiningDate",
            columnCode: "joiningDate",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Date of Commencement",
            type:INPUT_TYPE.DATE,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"dateOfSpore",
            columnCode: "dateOfSpore",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Date of Singapore PR status granted (if after 1 Jan 2018)",
            type:INPUT_TYPE.DATE,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        }
    ],
    sectionB: [
        {
            key:"employerscontribution",
            columnCode: "employerscontribution",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Employer's Contribution",
            type:INPUT_TYPE.NUMBER,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"employeescontribution",
            columnCode: "employeescontribution",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Employee's Contribution",
            type:INPUT_TYPE.NUMBER,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        }
    ],
    sectionC: {
        ordinaryWages: [
            {
                key: "amount",
                columnCode: "amount",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Amount",
                type: INPUT_TYPE.NUMBER,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            },
            {
                key: "period",
                columnCode: "period",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Period",
                type: 'date-range',
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: true,
                uiVisible: true
            },
            {
                key: "datePaid",
                columnCode: "datePaid",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Date paid",
                type: INPUT_TYPE.DATE,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            }
        ],
        amountOfRefundEmployer:[
            {
                key: "emrContribution",
                columnCode: "emrContribution",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Contribution",
                type: INPUT_TYPE.NUMBER,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            },
            {
                key: "emrInterest",
                columnCode: "emrInterest",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Interest",
                type: INPUT_TYPE.NUMBER,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            },
            {
                key: "emrDate",
                columnCode: "emrDate",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Date",
                type: INPUT_TYPE.DATE,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            }
        ],
        amountOfRefundEmployee:[
            {
                key: "empContribution",
                columnCode: "empContribution",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Contribution",
                type: INPUT_TYPE.NUMBER,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            },
            {
                key: "empInterest",
                columnCode: "empInterest",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Interest",
                type: INPUT_TYPE.NUMBER,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            },
            {
                key: "empDate",
                columnCode: "empDate",
                options: [],
                icon: "",
                validation: null,
                isValid: true,
                name: "Date",
                type: INPUT_TYPE.DATE,
                errorMessage: null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required: false,
                readOnly: false,
                uiVisible: true
            }
        ]
    },
    remark: [
        {
            key:"authorizePersonName",
            columnCode: "authorizePersonName",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Name of Employee",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"companyName",
            columnCode: "companyName",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Name of Employer",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"designation",
            columnCode: "designation",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Job Title",
            type:INPUT_TYPE.TEXT,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:false,
            readOnly: false,
            uiVisible: true
        },
        {
            key:"signedDate",
            columnCode: "signedDate",
            options:[],
            icon:"",
            validation:null,
            isValid:true,
            name:"Date of Sign",
            type:INPUT_TYPE.DATE,
            errorMessage:null,
            direction: INPUT_VIEW_DIRECTION.VERTICAL,
            required:true,
            readOnly: false,
            uiVisible: true
        }
        
    ]
}
export const SECTION_A_FORM = [
    {
        columnCode: "month",
        editable: false,
        hidden: false,
        id: "month",
        index: 0,
        name: "Month",
        options: null,
        required: false,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 110
    },
    {
        columnCode: "ordwages",
        editable: true,
        hidden: false,
        id: "ordwages",
        index: 0,
        name: "Ordinary Wages",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 150
    },
    {
        columnCode: "ordemployee",
        editable: true,
        hidden: false,
        id: "ordwages",
        index: 0,
        name: "CPF Contribution Employee",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 230
    },
    {
        columnCode: "ordemployer",
        editable: true,
        hidden: false,
        id: "ordemployer",
        index: 0,
        name: "CPF Contribution Employer",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 230
    },
    {
        columnCode: "addwages",
        editable: true,
        hidden: false,
        id: "addwages",
        index: 0,
        name: "Additional Wages",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 160
    },
    {
        columnCode: "addemployee",
        editable: true,
        hidden: false,
        id: "addemployee",
        index: 0,
        name: "CPF Contribution Employee",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 230
    },
    {
        columnCode: "addemployer",
        editable: true,
        hidden: false,
        id: "addemployer",
        index: 0,
        name: "CPF Contribution Employer",
        options: null,
        required: true,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 230
    }
]

export const TYPE_OF_PLANS = [
    {
      id: 'ESOP',
      name: 'ESOP'
    },
    {
      id: 'ESOW',
      name: 'ESOW'
    }
  ];
export const EXERCISES = [
    {
      id: 'Actual',
      name: 'Actual'
    },
    {
      id: 'Deemed',
      name: 'Deemed'
    }
];

export const APPENDIX_8B = [
    {
        columnCode: "Section1",
        isSection : false,
        fields: [
            { columnCode : "employeeFullName",type: INPUT_TYPE.TEXT  , name : "Full Name of employee as per NRIC/FIN", readOnly : true },
            { columnCode : "taxRefNo", type: INPUT_TYPE.TEXT, name: "Employees Tax. Re. No. NRIC/FIN", readOnly: true, showMask:true, showMaskUnmaskInline: true},
            { columnCode : "authorizePerson", type: INPUT_TYPE.DROPDOWN, name: "Authorised Person", validation:["required"]},
        ]
    },    
    { isSection:true, sectionNo:1, title:"Section A", description: "EMPLOYEE EQUITY-BASED REMUNERATION(EEBR) SCHEME", columnCode: "SectionA", defaultState: "expanded", section:[]},
    { isSection:true, sectionNo:2, title:"Section B ", description: "EQUITY REMUNERATION INCENTIVE SCHEME (ERIS) SMEs", columnCode: "SectionB", defaultState: "collapsed", section:[]},
    { isSection:true, sectionNo:3, title:"Section C", description: "EQUITY REMUNERATION INCENTIVE SCHEME (ERIS) ALL CORPORATIONS", columnCode: "SectionC", defaultState: "collapsed", section:[]},
    { isSection:true, sectionNo:4, title:"Section D", description: "EQUITY REMUNERATION INCENTIVE SCHEME (ERIS) START-UPs", columnCode: "SectionD", defaultState: "collapsed", section:[]},
]

export const APPENDIX_8B_SECTION_FIELDS = [
    {columnCode:"set1", title : "Set 1", defaultState: "collapsed", subSectionIndex : 0, fields: []},
    {columnCode:"set2", title : "Set 2", defaultState: "collapsed", subSectionIndex : 1, fields: []},
    {columnCode:"set3", title : "Set 3", defaultState: "collapsed", subSectionIndex : 2, fields: []},
]

export const APPENDIX_8B_FORM_SUB_SECTION_FIELDS = [
    {columnCode: "companyRegNo", name: "ID Number of Company", type: INPUT_TYPE.TEXT, maxLength:12, Validation: ["maxLength"], tooltipText:"Company Id number should not exceed 12 digits"},
    {columnCode: "companyName", name: "Name of Company", type: INPUT_TYPE.TEXT, maxLength:40, Validation: ["maxLength"], tooltipText:"Company name should not exceed 40 characters", tooltipClass: "tooltip-r1"},
    {columnCode: "planGrantedType", name: "Type of Plan Granted", type: INPUT_TYPE.DROPDOWN, options: TYPE_OF_PLANS},
    {columnCode: "planGrantDate", name: "Date of Grant", type: INPUT_TYPE.DATE},
    {columnCode: "exerciseDate", name: "Date of exercise of ESOP or date of vesting of ESOW Plan", type: INPUT_TYPE.DATE, validation:["basisYear"], tooltipText: "The year must be Income year."},
    {columnCode: "exercisePrice", name: "Exercise Price of ESOP/ or Price paid/Payable per share under ESOW Plans", type: INPUT_TYPE.NUMBER, maxLength:12, validation:["maxLength"], tooltipText:"Price should not exceed 12 digits", tooltipClass: "tooltip-r1"},
    {columnCode: "openMarketValueAtGrantDate", name: "Open Market Value Per Share as at the Date of Grant of ESOP / ESOW Plan", type: INPUT_TYPE.NUMBER, maxLength:12, validation:["maxLength"], tooltipText: "Price should not exceed 12 digits"},
    {columnCode: "openMarketValueAtExerciseDate", name: "Open Market Value Per Share as at the Date Reflected", type: INPUT_TYPE.NUMBER, maxLength:12, validation:["maxLength"], tooltipText: "Price should not exceed 12 digits", tooltipClass: "tooltip-r1"},
    {columnCode: "acquiredShareCount", name: "Number of shares Acquired", type: INPUT_TYPE.NUMBER, maxLength:12, validation:["maxLength"],tooltipText:"Number of shares acquired should not exceed 12 digits"},
    {columnCode: "typeOfExercise", name: "Type of Exercise", type: INPUT_TYPE.DROPDOWN, options:EXERCISES},
    {columnCode: "dateOfExpiryOfExercise", name: "Date of expiry of exercise of ESOP or Date of vesting of ESOW Plan", type: INPUT_TYPE.DATE},
    {columnCode: "noOfUnExercisedShares", name: "No. of unexercised ESOP or unvested shares under ESOW Plans or ESOP/ ESOW Plans with moratorium imposed", type: INPUT_TYPE.NUMBER, maxLength:12, validation:["maxLength"], tooltipText:"Value should not exceed 12 digits", tooltipClass: "tooltip-r1"} 
];

export const MANDATORY_FIELDS_FORMS = {
    ["IR8S"] : ["Company Number"],
    ["IR8A"]: ["Company Number"],
    ["APPENDIX_8A"] : ["Company Number"],
    ["APPENDIX_8B"] : ["Company Number"],
}